import React from 'react';
import Reveal from './Reveal';
import { stats } from '../mock';

const Stats = () => {
  return (
    <section className="py-16 md:py-20 bg-[#1a1a1a] text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        {stats.map((s, i) => (
          <Reveal key={s.label} delay={i * 100} className="text-center">
            <p className="font-serif text-[52px] md:text-[68px] text-[#e6396b] leading-none font-medium">
              {s.value}
            </p>
            <p className="mt-3 text-[11px] md:text-[12px] tracking-[0.3em] text-white/70 font-semibold">
              {s.label.toUpperCase()}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Stats;
